import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import PdfViewer from "../../PdfViewer";
import "../../incidentes.css";
import "bootstrap/dist/css/bootstrap.min.css";

const pasos = [
  { numero: 1, titulo: "Site Survey" },
  { numero: 2, titulo: "BOM" },
  { numero: 3, titulo: "Propuesta técnico-funcional" },
  { numero: 4, titulo: "Propuesta comercial" },
  { numero: 5, titulo: "SOW" },
  { numero: 6, titulo: "Kick-off" },
];

const formatearTamanio = (bytes) => {
  if (!bytes && bytes !== 0) return "";
  const unidades = ["B", "KB", "MB", "GB"];
  let valor = bytes;
  let i = 0;
  while (valor >= 1024 && i < unidades.length - 1) {
    valor /= 1024;
    i += 1;
  }
  return `${valor.toFixed(1)} ${unidades[i]}`;
};

const CreacionDocumentacion = () => {
  const [archivo, setArchivo] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    if (!archivo) {
      setPreviewUrl(null);
      return undefined;
    }
    const url = URL.createObjectURL(archivo);
    setPreviewUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [archivo]);

  const handleArchivoChange = (event) => {
    const file = event.target.files && event.target.files[0];
    setArchivo(file || null);
  };

  const esImagen = archivo && archivo.type.startsWith("image/");
  const esPdf = archivo && archivo.type === "application/pdf";

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Creación de Documentación</h1>
        </div>

        <div className="docgen-steps">
          {pasos.map((paso, index) => (
            <React.Fragment key={paso.numero}>
              <div className="docgen-step">
                <div className="docgen-step-circle">{paso.numero}</div>
                <div className="docgen-step-label">{paso.titulo}</div>
              </div>
              {index < pasos.length - 1 && (
                <div className="docgen-connector" aria-hidden="true">
                  →
                </div>
              )}
            </React.Fragment>
          ))}
        </div>

        <div className="docgen-grid">
          <div className="orgproc-card">
            <div className="orgproc-card-accent"></div>
            <div className="orgproc-card-body">
              <div className="orgproc-eyebrow">Paso 1</div>
              <div className="orgproc-card-title">Site Survey</div>
              <p className="orgproc-card-desc">
                Ingresa el documento de Site Survey del proyecto
                (mediciones, AP, cobertura, planos). A partir de este
                documento se generará la documentación de los siguientes
                pasos usando los machotes correspondientes.
              </p>
              <label className="docgen-upload-dropzone" htmlFor="site-survey-input">
                <input
                  id="site-survey-input"
                  type="file"
                  className="docgen-upload-input"
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg"
                  onChange={handleArchivoChange}
                />
                <span className="docgen-upload-icon">⬆</span>
                <span className="docgen-upload-text">
                  {archivo
                    ? archivo.name
                    : "Selecciona o arrastra el documento de Site Survey"}
                </span>
              </label>

              {archivo && (
                <div className="docgen-preview">
                  <div className="docgen-preview-header">
                    <span className="docgen-preview-name">{archivo.name}</span>
                    <span className="docgen-preview-size">
                      {formatearTamanio(archivo.size)}
                    </span>
                  </div>

                  {esImagen && (
                    <img
                      src={previewUrl}
                      alt={`Vista previa de ${archivo.name}`}
                      className="docgen-preview-image"
                    />
                  )}

                  {esPdf && (
                    <div className="docgen-preview-pdf">
                      <PdfViewer pdfUrl={previewUrl} />
                    </div>
                  )}

                  {!esImagen && !esPdf && (
                    <div className="docgen-preview-generic">
                      <span className="docgen-preview-generic-icon">📄</span>
                      <p className="docgen-preview-generic-text">
                        No hay vista previa disponible para este tipo de
                        archivo.
                      </p>
                      <a
                        href={previewUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="orgproc-card-btn"
                      >
                        Abrir archivo →
                      </a>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default CreacionDocumentacion;
